// extracted by mini-css-extract-plugin
export default {"container":"CompletedLessons_container__2wybJ","lesson":"CompletedLessons_lesson__KVqiA","event":"CompletedLessons_event__UbSDe","showMore":"CompletedLessons_showMore__uqKR2"};